import React, { useState } from 'react';
import { Upload, Grid } from 'react-feather';
import FileDrop from 'react-file-drop';

const EmptyState = ({ libraryCount, maxLabel, dimsLabel, onPickFile, onOpenLibrary, onFilesDropped }) => {
	const [dragging, setDragging] = useState(false);

	const handleDragOver = () => setDragging(true);
	const handleDragLeave = () => setDragging(false);
	const handleDrop = (files) => {
		setDragging(false);
		if (files && files.length) onFilesDropped(files);
	};

	return (
		<div className="image-upload-control__empty">
			<FileDrop onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave}>
				<button
					type="button"
					className={`image-upload-control__dropzone${dragging ? ' is-dragging' : ''}`}
					onClick={onPickFile}
					aria-label="Upload a CFS logo from your device"
				>
					<span className="image-upload-control__dropzone-icon" aria-hidden="true">
						<Upload size={22} />
					</span>
					<span className="image-upload-control__dropzone-title">
						{dragging ? 'Drop to upload' : 'Drag & drop a logo here'}
					</span>
					<span className="image-upload-control__dropzone-sub">
						or <span className="accent">browse files</span>
					</span>
					<span className="image-upload-control__dropzone-meta">
						PNG, JPG or SVG{maxLabel ? ` · up to ${maxLabel}` : ''}
						{dimsLabel ? ` · ${dimsLabel} recommended` : ''}
					</span>
				</button>
			</FileDrop>
			<button
				type="button"
				className="image-upload-control__library-card"
				onClick={onOpenLibrary}
				aria-label="Choose a logo from the library"
			>
				<span className="image-upload-control__library-icon" aria-hidden="true">
					<Grid size={21} />
				</span>
				<span className="image-upload-control__library-title">Choose from library</span>
				<span className="image-upload-control__library-count">
					{libraryCount} logo{libraryCount === 1 ? '' : 's'} available
				</span>
			</button>
		</div>
	);
};

export default EmptyState;
